import type { ReactNode } from 'react'
import type { UseFormReturn } from 'react-hook-form'

import type { AgencyFormSchemaType } from '../agency-form.schema'
import { AgencyLogoUpload } from '../agency-logo-upload.molecule'
import { AgencyFormNameField } from './agency-form-name-field.atom'
import { AgencyFormSlugField } from './agency-form-slug-field.atom'

interface AgencyFormIdentitySectionProps {
  form: UseFormReturn<AgencyFormSchemaType>
  logoPreviewUrl: string | null
  onLogoChange: (file: File | null) => void
  onLogoRemove: () => void
  isDisabled?: boolean
}

export const AgencyFormIdentitySection = ({
  form,
  logoPreviewUrl,
  onLogoChange,
  onLogoRemove,
  isDisabled = false,
}: AgencyFormIdentitySectionProps): ReactNode => (
  <div className="agency-form-identity flex gap-4">
    <AgencyLogoUpload
      logoUrl={logoPreviewUrl}
      name={form.watch('name')}
      onLogoChange={onLogoChange}
      onLogoRemove={onLogoRemove}
      isDisabled={isDisabled}
    />
    <div className="flex-1 space-y-4">
      <AgencyFormNameField form={form} isDisabled={isDisabled} />
      <AgencyFormSlugField form={form} isDisabled={isDisabled} />
    </div>
  </div>
)

AgencyFormIdentitySection.displayName = 'AgencyFormIdentitySection'
